/** Header mega-menu data — mirrors website/includes/nav.php (React routes). */
import { withBasePath } from '../utils/paths.js';

const img = (path) => withBasePath(`/${path}`);

/** Top-level Home is a plain link (no mega). See Navbar. */
export const MEGA_NAV = [
  {
    id: 'flights',
    label: 'Flights',
    to: '/flights',
    section: 'flights',
    columns: [
      {
        heading: 'Live & status',
        links: [
          { to: '/flights', label: 'Live flight board' },
          { to: '/flight-information', label: 'Flight information' },
          { to: '/airline-information', label: 'Airline information' },
          { to: '/destinations', label: 'Destinations' },
        ],
      },
      {
        heading: 'Guides',
        links: [
          { to: '/arrival-guide', label: 'Arrival guide' },
          { to: '/departure-guide', label: 'Departure guide' },
          { to: '/lounges', label: 'Lounges' },
        ],
      },
    ],
    promo: {
      to: '/flights',
      img: img('images/airport/departure-check-in-area.jpg'),
      label: 'Flights',
      text: 'Live boards, guides, and destinations',
      cta: 'Explore flights',
    },
  },
  {
    id: 'information',
    label: 'Information',
    to: '/information',
    section: 'information',
    columns: [
      {
        heading: 'Plan & prepare',
        links: [
          { to: '/information', label: 'Information hub' },
          { to: '/airport-map', label: 'Airport map' },
          { to: '/check-in', label: 'Check-in' },
          { to: '/baggage', label: 'Baggage' },
          { to: '/visa-info', label: 'Visa info' },
          { to: '/security', label: 'Security' },
          { to: '/special-assistance', label: 'Special assistance' },
        ],
      },
      {
        heading: 'Border & documents',
        links: [
          { to: '/immigration', label: 'Immigration procedures' },
          { to: '/arrival-card', label: 'Arrival card' },
          { to: '/prohibited-items', label: 'Prohibited items' },
          { to: '/customs-regulation', label: 'Customs regulation' },
        ],
      },
      {
        heading: 'Terminal',
        links: [
          { to: '/terminal-guides', label: 'Terminal guides' },
          { to: '/facilities-services', label: 'Facilities & services' },
          { to: '/travel-guidance', label: 'Travel guidance' },
          { to: '/overseas-payment', label: 'Overseas payment wallet' },
        ],
      },
    ],
    promo: {
      to: '/information',
      img: img('images/airport/airport-terminal-lobby.jpg'),
      label: 'Information',
      text: 'Maps, check-in, visas, and terminal guides',
      cta: 'Plan your visit',
    },
  },
  {
    id: 'transport',
    label: 'Transport',
    to: '/transport',
    section: 'transport',
    columns: [
      {
        heading: 'Getting here',
        links: [
          { to: '/transport', label: 'Transport hub' },
          { to: '/transport-directions', label: 'Transport & directions' },
          { to: '/parking', label: 'Parking' },
          { to: '/park-fly', label: 'Park & fly' },
          { to: '/leaving-airport', label: 'Leaving the airport' },
          { to: '/hotels', label: 'Hotels' },
        ],
      },
    ],
    promo: {
      to: '/transport',
      img: img('images/airport/airport-exterior-view.jpg'),
      label: 'Transport',
      text: 'Parking, directions, and hotels near NKC',
      cta: 'Getting here',
    },
  },
  {
    id: 'services',
    label: 'Services',
    to: '/services',
    section: 'services',
    columns: [
      {
        heading: 'Passenger services',
        links: [
          { to: '/services', label: 'Services hub' },
          { to: '/vip-service', label: 'VIP Lounge' },
          { to: '/assistance', label: 'Assistance' },
          { to: '/contact', label: 'Contact' },
          { to: '/faqs', label: 'FAQs' },
        ],
      },
    ],
    promo: {
      to: '/services',
      img: img('images/airport/airport-vip-lounge-seating.jpg'),
      label: 'Services',
      text: 'VIP Lounge, assistance, and passenger support',
      cta: 'View services',
    },
  },
  {
    id: 'cargo',
    label: 'Cargo and freight',
    to: '/cargo',
    section: 'cargo',
    columns: [
      {
        heading: 'Cargo at NKC',
        links: [
          { to: '/cargo', label: 'Cargo and freight' },
          { to: '/cargo-services', label: 'Cargo services' },
          { to: '/cargo-handling', label: 'Handling & operations' },
          { to: '/cargo-facilities', label: 'Facilities & warehouses' },
        ],
      },
      {
        heading: 'For freight partners',
        links: [
          { to: '/cargo-tracking', label: 'Track shipments' },
          { to: '/cargo-rates', label: 'Tariffs & charges' },
          { to: '/cargo-perishables', label: 'Perishables & special cargo' },
          { to: '/contact?topic=cargo', label: 'Cargo enquiries' },
        ],
      },
    ],
    promo: {
      to: '/cargo',
      img: img('images/cargo/cargo (2).jpg'),
      label: 'Cargo and freight',
      text: 'Freight, handling, and logistics at NKC',
      cta: 'Cargo and freight',
    },
  },
  {
    id: 'experience',
    label: 'Experience',
    to: '/experience',
    section: 'experience',
    columns: [
      {
        heading: 'Dine & shop',
        links: [
          { to: '/experience', label: 'Experience hub' },
          { to: '/dining', label: 'Dining' },
          { to: '/shopping', label: 'Shopping' },
          { to: '/retail-leisure', label: 'Retail & leisure' },
          { to: '/duty-free', label: 'Duty-free' },
          { to: '/tax-refund', label: 'Tax refund' },
          { to: '/shop-online', label: 'Shop online' },
          { to: '/shopping-concierge', label: 'Shopping concierge' },
          { to: '/mobile-pay', label: 'Mobile pay' },
        ],
      },
      {
        heading: 'Leisure & events',
        links: [
          { to: '/attractions', label: 'Attractions' },
          { to: '/book-attractions', label: 'Book attractions' },
          { to: '/kids-experience', label: 'Experiences for kids' },
          { to: '/free-tours', label: 'Free tours' },
          { to: '/quiet-zones', label: 'Quiet zones' },
          { to: '/spa-wellness', label: 'Spa & wellness' },
          { to: '/events', label: 'Events' },
          { to: '/promotions', label: 'Promotions' },
        ],
      },
      {
        heading: 'Discover Mauritania',
        links: [
          { to: '/welcome-mauritania', label: 'Welcome Mauritania' },
          { to: '/experience-mauritania', label: 'Experience Mauritania' },
          { to: '/sahara-atlantic', label: 'Where the Sahara meets the Atlantic' },
          { to: '/gallery', label: 'Gallery' },
        ],
      },
    ],
    promo: {
      to: '/experience',
      img: img('images/airport/airport-shopping-area.jpg'),
      label: 'Experience',
      text: 'Dining, shopping, and leisure at NKC',
      cta: 'Discover more',
    },
  },
  {
    id: 'business',
    label: 'Business',
    to: '/business',
    section: 'business',
    columns: [
      {
        heading: 'Company & partners',
        links: [
          { to: '/business', label: 'Business hub' },
          { to: '/business-opportunities', label: 'Business opportunities' },
          { to: '/corporate', label: 'Policy, mission & awards' },
          { to: '/aviation', label: 'Aviation' },
        ],
      },
      {
        heading: 'Commercial',
        links: [
          { to: '/aera-charges', label: 'Airport charges' },
          { to: '/conditions-of-use-rates', label: 'Conditions of use – Rates' },
          { to: '/plan-events', label: 'Plan your events' },
          { to: '/contact?topic=commercial', label: 'Commercial contact' },
        ],
      },
    ],
    promo: {
      to: '/business',
      img: img('images/airport/airport-exterior-view.jpg'),
      label: 'Business',
      text: 'Partnerships and commercial programmes',
      cta: 'Partner with us',
    },
  },
];
